import {
  post_request
} from '../axiosFun';

//车辆列表
export const get_cars_list = (params) => {
   params = {
    row: {
      car_id: params.vin,
      car_number:params.car_number,
      car_type: params.name,
      page_no: params.page,
      page_size: params.limit,
    }
  }
  return post_request("/web/car/get_cars",params)
};
// 添加车辆
// export const get_cars_add = (params) => {
//     params = {
//         row:{
//             car_id:params.car_id,
//             car_number:params.car_number,
//             car_type:params.car_type,
//             car_voltage:params.car_voltage,
//             car_motor_power:params.car_motor_power,
//             car_max_speed:params.car_max_speed,
//             car_load_mass:params.car_load_mass,
//             car_curb_weight:params.car_curb_weight,
//             manufacturing_date:params.manufacturing_date,
//             car_color:params.car_color,
//             car_battery_capacity:params.car_battery_capacity,
//             car_brand:params.car_brand,
//             car_comment:params.car_comment || '',
//         }
//     }
//     return post_request("/web/car/get_cars",params)
// };
//获取单条车辆信息
export const get_one_car = (params) => {

  params = {
    row: {
      id: params
    }
  }
  return post_request("/web/car/get_one", params)
};
//修改车辆信息
export const get_cars_edit = (params) => {
  params = {
    row: {
      id: params.id,
      remark: params.remark || '',
    }
  }
  return post_request("/web/car/edit", params)
};
//获取所有车辆型号
export const get_all_car_type = (params) => {
  params = {
    row: {}
  }
  return post_request("/web/carType/get_list", params)
};
//修改状态
export const get_switch_status = (params, status) => {
  params = {
    row: {
      id: params,
      status: status
    }
  }
  return post_request("/web/car/switch_status", params)
};
//导入车辆信息
export const get_import_id_name = (params) => {
  params = {
    row: {
      car_id: params.vin,
      car_number:params.car_number,
      car_type: params.name,
      page_no: params.page,
      page_size: params.limit,
    }
  }
  return post_request("/web/car/get_import", params)
};
//添加车辆信息
export const get_import_data_add = (params) => {
  params = {
    row: {
      vins: params,
    }
  }
  return post_request("/web/car/import", params)
};
// //获取司机
// export const get_driver_id_name = (params) => {
//   params = {
//     row: {}
//   }
//   return post_request("/web/car/get_driver_id_name", params)
// };
// //绑定司机
// export const get_driver_binding = (params) => {
//   params = {
//     row: {
//       id:window.localStorage.getItem("car"),
//       driver_id:params
//     }
//   }
//   return post_request("/web/car/binding", params)
// };
// //解绑司机
// export const get_unbind_driver = (params) => {
//   params = {
//     row: {
//       id:params
//     }
//   }
//   return post_request("/web/car/unbind_driver", params)
// };
//删除车辆
export const get_car_del = (params) => {
  params = {
    row: {
      id: params,
    }
  }
  return post_request("/web/car/del", params)
};



// WEBPACK FOOTER //
// ./src/api/car_mn/api.js